"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TwitchRoutes = void 0;
const base_1 = require("../base");
const constants_1 = require("../constants");
/**
 * API routes for Twitch bot management
 * Handles all operations related to Twitch bot configuration and channels
 */
class TwitchRoutes extends base_1.ApiBase {
    /**
     * Update Twitch bot configuration for the current authenticated user
     * @param config - The configuration updates to apply
     * @returns Promise resolving when the update is complete
     * @throws Error if the API request fails or user is not authenticated
     */
    async updateTwitchBotConfig(config) {
        return this.apiPatch(`${constants_1.ROUTES.TWITCH}/config`, config);
    }
    /**
     * Join a Twitch channel with the bot
     * @param twitchUsername - The Twitch username/channel to join
     * @returns void
     * @throws Error if the API request fails or user is not authenticated
     */
    async joinTwitchChannel(twitchUsername) {
        const payload = twitchUsername ? { channel: twitchUsername } : {};
        return this.apiPost(`${constants_1.ROUTES.TWITCH}/join`, payload);
    }
    /**
     * Leave a Twitch channel with the bot
     * @param twitchUsername - The Twitch username/channel to leave
     * @returns void
     * @throws Error if the API request fails or user is not authenticated
     */
    async leaveTwitchChannel(twitchUsername) {
        const payload = twitchUsername ? { channel: twitchUsername } : {};
        return this.apiPost(`${constants_1.ROUTES.TWITCH}/leave`, payload);
    }
    /**
     * Get list of Twitch channels that the bot is currently in
     * @returns Promise resolving to array of channel names
     * @throws Error if the API request fails or user is not authenticated
     */
    async getTwitchBotChannels() {
        return this.apiGet(`${constants_1.ROUTES.TWITCH}/channels`);
    }
}
exports.TwitchRoutes = TwitchRoutes;
//# sourceMappingURL=twitch.js.map